import { Accordion, Header, Icon } from './';
import React, { Component } from 'react';

class HideableSection extends Component {
  state = { active: this.props.defaultActive };

  onHeaderClick = () => {
    this.setState(({ active }) => ({ active: !active }));
  };

  render() {
    const { header, headerAs, children } = this.props;
    const { active } = this.state;

    const SectionHeader = props => (
      <Header {...props} as={headerAs}>
        <Icon name="dropdown" />
        {header}
      </Header>
    );

    return (
      <Accordion>
        <Accordion.Title
          as={SectionHeader}
          onClick={this.onHeaderClick}
          active={active}
        />
        <Accordion.Content active={active}>{children}</Accordion.Content>
      </Accordion>
    );
  }
}

export default HideableSection;



// WEBPACK FOOTER //
// ./src/components/HideableSection.js